<template>
  <div>
    <div class="consonant-list align-center">
      <button type="button" :class="{on: initial === 'ㄱ'}" @click="search('ㄱ')">ㄱ</button>
      <button type="button" :class="{on: initial === 'ㄴ'}" @click="search('ㄴ')">ㄴ</button>
      <button type="button" :class="{on: initial === 'ㄷ'}" @click="search('ㄷ')">ㄷ</button>
      <button type="button" :class="{on: initial === 'ㄹ'}" @click="search('ㄹ')">ㄹ</button>
      <button type="button" :class="{on: initial === 'ㅁ'}" @click="search('ㅁ')">ㅁ</button>
      <button type="button" :class="{on: initial === 'ㅂ'}" @click="search('ㅂ')">ㅂ</button>
      <button type="button" :class="{on: initial === 'ㅅ'}" @click="search('ㅅ')">ㅅ</button>
      <button type="button" :class="{on: initial === 'ㅇ'}" @click="search('ㅇ')">ㅇ</button>
      <button type="button" :class="{on: initial === 'ㅈ'}" @click="search('ㅈ')">ㅈ</button>
      <button type="button" :class="{on: initial === 'ㅊ'}" @click="search('ㅊ')">ㅊ</button>
      <button type="button" :class="{on: initial === 'ㅋ'}" @click="search('ㅋ')">ㅋ</button>
      <button type="button" :class="{on: initial === 'ㅌ'}" @click="search('ㅌ')">ㅌ</button>
      <button type="button" :class="{on: initial === 'ㅍ'}" @click="search('ㅍ')">ㅍ</button>
      <button type="button" :class="{on: initial === 'ㅎ'}" @click="search('ㅎ')">ㅎ</button>
      <button type="button" :class="{on: initial === '기타'}" @click="search('기타')">기타</button>
    </div>

    <div class="search-result">
      <span class="total">검색결과 <span class="num">{{ totalCount }}</span>건</span>
      <ul class="search-result-list">
        <li v-for="(item, idx) in items" v-bind:key="idx">
          <a href="#/" @click="openStatisticsPopup(item.upPath, item.levelId2, item.tblMgmNo)">
            <div class="title-address">
              <strong class="result-title">{{ item.tblKorNm }}</strong>
              <div class="address">
                <span>{{ item.upPath }}</span>
              </div>
            </div>
          </a>
        </li>
      </ul>
      <div class="btn-layout center" v-show="hasMoreData">
        <button type="button" class="line btn" @click="searchMore">더보기</button>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/Statistics";

export default {
  name: "SubjectInitialSearchView",
  props: {
    statId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      totalCount: 0,
      items: [],
      initial: '',
      pageSize: 10,
      pageIndex: 0,
      startPage: 0,
      endPage: 0,
      hasMoreData: false,
    }
  },
  methods: {
    reload() {
      if (!this.initial) this.search('ㄱ');
    },

    /**
     * 명칭검색 내 글자 버튼 클릭 시
     *
     * @param initial
     * @returns {Promise<void>}
     */
    async search(initial) {
      this.pageIndex = 0;
      this.startPage = 0;
      this.endPage = 0;
      this.initial = initial;
      await this.searchMore();
    },

    /**
     * 명칭검색
     *
     * @returns {Promise<void>}
     */
    async searchMore () {
      this.pageIndex++;
      this.startPage = ((this.pageIndex - 1) * this.pageSize) + 1;
      this.endPage = this.pageIndex * this.pageSize;

      const result = await api.statisticsInitialList({
        initialText: this.initial,
        levelId2: this.statId,
        startPage: this.startPage,
        endPage: this.endPage
      });

      if (this.pageIndex === 1) {
        this.items.splice(0, this.items.length, ...result.data);
      } else {
        this.items.push(...result.data);
      }

      this.hasMoreData = result.data.length >= this.pageSize;
      this.totalCount = result.cnt;
    },

    /**
     * 통계표 새창 띄우기
     *
     * @param upPath
     * @param levelId2
     * @param statId
     */
    openStatisticsPopup(upPath, levelId2, statId) {
      this.$emit('show-statistics-popup',upPath, levelId2, statId);
    },
  },
}
</script>

<style scoped>

</style>
